/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useState } from 'react';
import './SearchInputV1.scss';
import { SearchThick, CrossCircle } from 'sushiweb/Icons';
import { grey } from 'sushiweb/tokens/color';
import { orgBasedHeaderUI, orgIdKey } from '../../widgets/OrgIdDropdown/utils';
import { DropdownWrapperV1 } from '../../../UiKit/dropdown/dropdownV1';

const dropDownValues = {
  order_id: 'Order ID',
  gr_id: 'ORD ID',
  cart_id: 'Cart ID',
  user_id: 'Customer ID',
  user_number: 'Customer Phone Number',
  email_id: 'Customer Email',
  valet_id: 'Delivery Partner ID',
  valet_number: 'Delivery Partner Number',
};

const piiFields = ['email_id', 'user_number', 'valet_number'];

export const SearchInputV1 = forwardRef(
  (
    {
      inputVal = '',
      dropdownVal = '',
      isDropdown = true,
      isCross = false,
      onSelect = () => {},
      onChange = () => {},
      onClick = () => {},
      onKeyPress = () => {},
      clearSearch = () => {},
    },
    ref,
  ) => {
    const [currentOrg, setCurrentOrg] = useState();
    useEffect(() => {
      const currentOrgKey = sessionStorage.getItem(orgIdKey);
      setCurrentOrg(currentOrgKey);
    }, [sessionStorage.getItem(orgIdKey)]);
    const getPlaceholderText = () => {
      let placeholderText = `Enter the Order ID here...`;
      for (let [key, value] of Object.entries(dropDownValues)) {
        if (dropdownVal === key) placeholderText = `Enter the ${value} here...`;
      }
      if (['user_number'].includes(dropdownVal)) {
        placeholderText =
          'For international numbers, use country code. Ex +91...';
      }
      return placeholderText;
    };
    const getInputType = () => {
      let inputType = 'text';
      if (dropdownVal === 'user_email') {
        inputType = 'email';
      }
      return inputType;
    };

    const filterInput = (e) => {
      if (e.target.type === 'number') {
        e.key === 'e' && e.preventDefault();
      }
    };

    return (
      <div className='searchInput tw-rounded-xl focus-within:!tw-border focus-within:!tw-border-solid focus-within:!tw-border-base-green focus-within:tw-outline focus-within:tw-outline-2 focus-within:tw-outline-green-700/10 focus-within:!tw-border-r-0'>
        {!!isDropdown && (
          <>
            <div
              className='dropdown'
              css={`
                :first-child > div > div > div > div {
                  max-height: 4.4rem;
                }
              `}
            >
              <DropdownWrapperV1
                isNaked={true}
                dropDownValues={dropDownValues}
                dropdownVal={dropdownVal}
                onSelect={onSelect}
              />
            </div>
            <div className='divider'>
              <span></span>
            </div>
          </>
        )}
        <div className='searchInputWrapper'>
          <input
            className={`medium ${isDropdown ? '' : 'noDropdown'}`}
            type={getInputType()}
            placeholder={getPlaceholderText()}
            value={inputVal}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onKeyDown={filterInput}
            onFocus={(e) => {
              e.target.select();
            }}
            min='0'
            ref={ref}
            data-dd-privacy={
              piiFields.includes(dropdownVal) ? 'mask' : undefined
            }
          />
          {!!isCross && (
            <span
              className='crossIcon pointer'
              onClick={clearSearch}
              data-dd-action-name='Clear Search'
            >
              <CrossCircle size={16} color={grey.z300} />
            </span>
          )}
        </div>
        <div
          className={`searchIcon ${
            currentOrg
              ? orgBasedHeaderUI[currentOrg]?.searchIconColor
              : 'tw-bg-green-700'
          }`}
          onClick={onClick}
          data-dd-action-name='Search Orders'
        >
          <SearchThick color='white' />
        </div>
      </div>
    );
  },
);
